function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#2c2c2c",
  d: "M14.747 5.413c1.43 0 2.59 1.16 2.59 2.59v13.735c0 .617-.697.976-1.2.618l-5.968-4.264L4.2 22.356c-.502.358-1.2 0-1.2-.618V8.003c0-1.43 1.16-2.59 2.59-2.59h9.157zm0 1.518H5.59c-.592 0-1.072.48-1.072 1.072v12.26l5.21-3.721c.263-.189.618-.189.882 0l5.21 3.721V8.003c0-.592-.48-1.072-1.073-1.072zM18.41 1.75c1.43 0 2.59 1.16 2.59 2.59v14.651c0 .42-.34.759-.759.759-.42 0-.76-.34-.76-.759V4.341c0-.593-.48-1.073-1.071-1.073H8.337c-.419 0-.759-.34-.759-.759 0-.42.34-.759.76-.759H18.41z"
});

var SvgIcBrands = function SvgIcBrands(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcBrands, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_brands.0209d6f2.svg";
export { ForwardRef as ReactComponent };